export async function offlineShellReady() {
  if (window.Capacitor?.isNativePlatform?.()) return true;
  if (!('serviceWorker' in navigator) || !window.isSecureContext) return false;
  let timer;
  try {
    const timeout = new Promise(resolve => { timer = setTimeout(() => resolve(null),10000); });
    const registration = await Promise.race([navigator.serviceWorker.ready,timeout]);
    if (!registration?.active) return false;
    return await new Promise(resolve => {
      const channel = new MessageChannel(), deadline = setTimeout(() => {channel.port1.close();resolve(false);},3000);
      channel.port1.onmessage = event => {clearTimeout(deadline);channel.port1.close();resolve(event.data?.ready === true&&event.data?.version==='v242');};
      registration.active.postMessage({type:'offline-shell-status'},[channel.port2]);
    });
  } catch (_) { return false; }
  finally { clearTimeout(timer); }
}
